<template>
  <Accordion
    :error="$v.nfse.payments.$error"
    id="payments"
    title="FORMA DE PAGAMENTO"
  >
    <b-row class="row-padding">
      <b-col md="6">
        <b-row>
          <b-col md="12">
            <SelectPayment
              v-model="payment"
              :disabled="
                (this.valorUS(value) <= 0 && !isPaymentNone) ||
                this.payment.isEditing
              "
              @change="changePayment"
            />
          </b-col>
        </b-row>
        <b-row class="table-installments mt-4" v-show="isValidPayment">
          <b-col md="12">
            <InstallmentTableV2
              :items="payment.range"
              :totalPaymentAmount="value"
              @changeInstallments="changeInstallments"
            />
          </b-col>
        </b-row>
        <b-row class="row-padding mt-2" v-if="!payment.isEditing">
          <Button
            v-if="!disabled"
            align="center"
            class="text-center ml-2"
            type="success"
            :fullWidth="true"
            :disabled="!isValidPayment || !isValidInstallments"
            @click="addPayment()"
          >
            Adicionar
          </Button>
        </b-row>
        <b-row class="row-padding mt-2" v-else>
          <b-col md="6">
            <Button
              align="center"
              class="text-center"
              type="success"
              :fullWidth="true"
              @click="saveEditPayment()"
            >
              Alterar
            </Button>
          </b-col>
          <b-col md="6">
            <Button
              align="center"
              class="text-center"
              type="error"
              :fullWidth="true"
              @click="cancelEditPayment()"
            >
              Cancelar
            </Button>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col md="12" lg="6">
            <InputMoney
              id="value"
              label="Valor"
              :disabled="disabled || isPaymentNone"
              :precision="2"
              :onKeyup="changePaymentValue"
              v-model="value"
            />
          </b-col>
          <b-col md="12" lg="6">
            <SelectAccount :disabled="disabled" v-model="account" />
          </b-col>
          <b-col md="12" class="mt-3">
            <Label>Informações Complementares:</Label>
            <b-textarea
              class="input"
              :disabled="disabled"
              :maxlength="255"
              no-resize
              v-model="nfse.generalInformation.additionalInformation"
            ></b-textarea>
          </b-col>
          <b-col md="12" class="mt-3">
            <SelectCategory
              :disabled="disabled"
              :types="[categoryEnum.REVENUE, categoryEnum.EXPENSE_AND_REVENUE]"
              v-model="category"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="end" class="row-padding">
      <b-col md="6" class="mt-2">
        <b-row align-h="end">
          <b-col md="12" lg="7" align="right">
            <strong>Total Restante:</strong>
            {{ remainder }}
          </b-col>
          <b-col md="12" lg="5" align="right">
            <strong>Total:</strong>
            {{ total }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      class="form-group row-padding"
      v-if="nfse.payments.paymentModeCollection.length"
    >
      <b-col class="busca">
        <table class="table">
          <thead>
            <tr>
              <th>Pagamento</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment, key) in nfse.payments.paymentModeCollection"
              :key="'payment' + key"
            >
              <td>{{ payment.name }}</td>
              <td>R$ {{ valorReal(payment.value) }}</td>
              <td align="right">
                <a
                  v-if="!disabled && payment.range.length"
                  href="javascript:"
                  class="text-muted mr-2"
                  @click="editPayment(key)"
                >
                  <Edit title="Editar" />
                </a>
                <a
                  v-if="!disabled"
                  href="javascript:"
                  class="text-muted"
                  @click="removePayment(key)"
                >
                  <Close title="Fechar" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import { NENHUM } from '@/modules/Inventory/modules/Payment/enums/PaymentModeTypeEnum';
import {
  Accordion,
  SelectPayment,
  SelectAccount,
  SelectCategory,
  InstallmentTableV2,
} from '@/components';
import { CategoryEnum } from '@/modules/Finance/enums/CategoryEnum';
import { Button, InputMoney, Label } from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import { required } from '@/reusable/validations';
import InstallmentsMixin from '@/modules/Application/mixins/InstallmentsMixin';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Close from 'vue-material-design-icons/Close';
import Edit from 'vue-material-design-icons/Pencil';

export default {
  name: 'Payment',
  mixins: [FormatMixin, InstallmentsMixin],
  components: {
    Accordion,
    Close,
    Edit,
    Button,
    InputMoney,
    InstallmentTableV2,
    Label,
    SelectPayment,
    SelectCategory,
    SelectAccount,
  },
  data() {
    return {
      indexEdit: null,
      payment: {
        isEditing: false,
        account: null,
        category: null,
        range: [],
      },
      account: null,
      category: null,
      value: 0,
      categoryEnum: CategoryEnum,
    };
  },
  validations: {
    nfse: {
      payments: {
        paymentModeCollection: { required },
      },
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('nfse', ['nfse']),
    ...mapState('payment', ['paymentCollection']),

    total() {
      return `R$ ${this.valorReal(this.nfse.taxes.total)}`;
    },
    remainder() {
      return `R$ ${this.valorReal(this.nfse.payments.remainder)}`;
    },
    isValidPaymentValue() {
      return (
        this.valorUS(this.value) <= this.nfse.payments.remainder &&
        this.valorUS(this.value) > 0
      );
    },
    isValidInstallments() {
      return this.payment.range?.every((e) => this.valorUS(e.value) > 0);
    },
    isValidPayment() {
      return (
        (!!this.payment?.paymentModeId && this.isValidPaymentValue) ||
        this.payment.isEditing
      );
    },
    isPaymentNone() {
      return this.payment.paymentType?.tPag === NENHUM;
    },
  },
  methods: {
    ...mapActions('nfse', ['setRemainder']),

    setDefaultFields() {
      const { paymentModeCollection } = this.nfse.payments;
      if (!paymentModeCollection.length) {
        this.setPaymentModeToNone();
      }
    },
    setPaymentModeToNone() {
      const paymentNone = this.paymentCollection.find(
        (e) => e.paymentType.tPag === NENHUM,
      );
      const serializedPaymentNone = {
        ...paymentNone,
        isEditing: false,
        paymentModeId: paymentNone.id,
        value: 0,
        id: undefined,
        range: [],
      };

      this.nfse.payments.paymentModeCollection.push(serializedPaymentNone);

      this.setRemainder();
      this.clearPayment();
    },
    clearPayment() {
      this.payment = [];
    },
    async addPayment() {
      this.payment.value = this.calcTotalRange(this.payment.range);
      this.payment.account = this.account;
      this.payment.category = this.category;

      this.nfse.payments.paymentModeCollection.push(this.payment);

      this.nfse.payments.edited = true;
      await this.setRemainder();

      this.clearPayment();
    },
    async removePayment(index) {
      this.nfse.payments.paymentModeCollection.splice(index, 1);
      this.nfse.payments.edited = true;

      await this.setRemainder();
    },
    editPayment(index) {
      const { paymentModeCollection } = this.nfse.payments;

      this.payment = paymentModeCollection[index];
      this.account = this.payment.account;
      this.category = this.payment.category;
      this.value = this.payment.value;

      this.payment.isEditing = true;
      this.indexEdit = index;
    },
    async saveEditPayment() {
      this.payment.isEditing = false;
      this.nfse.payments.paymentModeCollection.splice(this.indexEdit, 1);

      await this.addPayment();

      this.indexEdit = null;
    },
    cancelEditPayment() {
      this.clearPayment();
    },
    changeInstallments(installments) {
      this.payment.range = installments;
    },
    changePayment(data) {
      if (!data) {
        this.clearPayment();
        return;
      }

      if (this.isPaymentNone) {
        this.value = 0;
        return;
      }

      this.value = this.nfse.payments.remainder;
      const range = this.calculateInstallments(this.payment, this.value);

      this.serializePayment(range);
    },
    async changePaymentValue() {
      if (!this.isValidPayment) return;

      this.payment.range = this.calculateInstallments(this.payment, this.value);
    },
    serializePayment(range) {
      this.payment = {
        ...this.payment,
        isEditing: false,
        paymentModeId: this.payment.id,
        value: this.valorUS(this.value),
        id: undefined,
        range,
      };
    },
  },
  watch: {
    'nfse.payments.remainder': function changeRemainder() {
      this.value = this.nfse.payments.remainder;
    },
  },
};
</script>;
<style>
.table-installments {
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
